import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "../control-factory";

interface ButtonsAndLabels { buttons: FlexiButton[]; labels: FlexiText[]; }

export class AutoRadioControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [];
    }

    protected getButtonsAndLabels(layer: Layers, name: string): ButtonsAndLabels {
        const buttons: FlexiButton[] = [];
        const labels: FlexiText[] = [];

        let id = 1;
        let activeButton: FlexiButton = layer.getFlexiButton(`${name}_radio_${id}`);
        let activeLabel: FlexiText = layer.getFlexiText(`${name}_radio_${id}_label`);
        while (activeButton) {
            buttons.push(activeButton);
            if (activeLabel) {
                labels.push(activeLabel);
            }

            id++;
            activeButton = layer.getFlexiButton(`${name}_radio_${id}`);
            activeLabel = layer.getFlexiText(`${name}_radio_${id}_label`);
        }

        return { buttons, labels };
    }
}
